










import { features } from "@/store";
import { ILinealPlatforms } from "@/store/features/models";
import Vue from "vue";
import Component from "vue-class-component";
import { LGeoJson } from "vue2-leaflet";
import { Layer } from "leaflet";

@Component({
  components: {
    LGeoJson,
  },
})
export default class LinealPlatformsLayer extends Vue {
  //computed

  get platforms() {
    return features.getters.linealPlatforms;
  }
  get geoJsonOptions() {
    return {
      onEachFeature: this.onEachFeatureFunction,
    };
  }
  get styleFunction() {
    return () => {
      return {
        weight: 1,
        color: "black",
      };
    };
  }
  get onEachFeatureFunction() {
    return (feature: ILinealPlatforms, layer: Layer) => {
      layer.bindTooltip(feature.properties.nombre, {
        permanent: false,
        sticky: true,
      });
    };
  }

  //methods
  loadFeatures() {
    if (!this.platforms.length) {
      features.dispatch("getLinealPlatforms");
    }
  }

  created() {
    this.loadFeatures();
  }
}
